import { useContext, useEffect, useState } from 'react'

import { AuthContext } from '../../contexts/AuthContext'

import { Trainings } from './trainings'
import CustomSlider from 'components/CustomSlider'
import { Webisodes } from './webisodes'
import { Contacts } from './contacts'
import { ChartsArea } from './chartsArea'

export const Dashboard = () => {
  const [_modalVisibility, setModayVisibility] = useState(false)
  const { currentUser } = useContext(AuthContext)

  useEffect(() => {
    if (currentUser && (!currentUser?.Birthdate || !currentUser?.IdCard)) {
      setModayVisibility(true)
    }
  }, [currentUser])

  return (
    <div className="w-full px-6 py-11 h-full overflow-auto max-w-[1900px] m-auto ">
      <div className="w-full grid grid-cols-1 gap-5 mb-5">
        <div className="rounded-xl overflow-hidden w-full m-auto drop-shadow-xl">
          <CustomSlider />
        </div>
      </div>

      <div className="w-full grid grid-cols-1 xl:grid-cols-2 gap-5  mb-5">
        <div className="rounded-xl overflow-hidden w-full h-auto drop-shadow-xl">
          <Webisodes />
        </div>

        <div className="rounded-xl overflow-hidden w-full h-auto drop-shadow-xl">
          <Trainings />
        </div>
      </div>

      <div className="w-full grid grid-cols-1 gap-5 mb-5 ">
        <div className="rounded-xl overflow-hidden w-full h-auto lg:h-auto drop-shadow-xl">
          <Contacts />
        </div>
      </div>

      <ChartsArea />
    </div>
  )
}
